import { Geolocation } from '@capacitor/geolocation'
import { Capacitor } from '@capacitor/core'
let store = undefined
export default{
  computed:{ 
  },
  mounted(){    
    store = this.$store
  },
  methods:{  

    // checkIfEmployeeGeofencingEnabled(){
    //   return store.getters.EMPLOYEE_DATA?.geofencing?.enabled_for_employee
    // },

    // checkGeofencingClockinEnabled(){
    //   const enabled = store.getters.EMPLOYEE_DATA?.geofencing?.enabled
    //   const propertyAreas = store.getters.EMPLOYEE_DATA?.geofencing?.property_areas
    //   const clockinAreas = store.getters.EMPLOYEE_DATA?.geofencing?.clockin_areas
    //   const clockinType = store.getters.EMPLOYEE_DATA?.geofencing_clockin_type

    //   // if geofencing not enabled for worker department 
    //   // or property areas are not drawn 
    //   // or clock in geofeencing is not enabled for current worker
    //   if(!enabled || propertyAreas.length == 0 || clockinType == 0){
    //     return false
    //   }

    //   // check if clockin type is 2 (property area) 
    //   // or check if clockin type is 1 (clockin area) && clockin areas are also drawn
    //   if(clockinType == 2 || (clockinType == 1 && clockinAreas.length > 0)){
    //     return true
    //   }

    //   return false
    // },
    // checkGeofencingClockoutEnabled(){
    //   const enabled = store.getters.EMPLOYEE_DATA?.geofencing?.enabled
    //   const propertyAreas = store.getters.EMPLOYEE_DATA?.geofencing?.property_areas
    //   const clockinAreas = store.getters.EMPLOYEE_DATA?.geofencing?.clockin_areas
    //   const clockoutType = store.getters.EMPLOYEE_DATA?.geofencing_clockout_type

    //   // if geofencing not enabled for worker department 
    //   // or property areas are not drawn 
    //   // or clock out geofeencing is not enabled for current worker
    //   if(!enabled || propertyAreas.length == 0 || clockoutType == 0){
    //     return false
    //   }

    //   // check if clockout type is 2 (property area) 
    //   // or check if clockout type is 1 (clockin area) && clockin areas are also drawn
    //   if(clockoutType == 2 || (clockoutType == 1 && clockinAreas.length > 0)){
    //     return true
    //   }

    //   return false
    // },  
    // async getClockingInArea(clockingInOutType = 'clockin'){
    //   let clockingArea = null
    //   const permission =  await this.getLocationPermission()
    //   console.log('Permission: ', permission)

    //   if(permission.granted) {
    //     const position = await this.getCurrentLocation()
    //     if(position){
    //       if(clockingInOutType == 'clockin'){
    //         clockingArea = await this.ifUserInsideAreaForClockin(position)
    //       }
    //       else if(clockingInOutType == 'clockout'){
    //         clockingArea = await this.ifUserInsideAreaForClockout(position)
    //       }
    //       if(clockingArea === null){
    //         this.$root.$emit('show-clocking-outside-area-modal', clockingInOutType)
    //         return null
    //       }
    //       else{
    //         return clockingArea
    //       }
    //     }
    //     else{
    //       this.showToast('danger', this.$t('1125'), this.$t('1126'))
    //     }
    //   } else if (permission.reason === 'denied') {
    //     this.$root.$emit('show-enable-location-permission-modal')
    //     return null
    //   } else if (permission.reason === 'prompt-denied') {
    //     // User denied location after being prompted
    //     const type = (clockingInOutType == 'clockin') ? 'clock in' : 'clock out'
    //     this.showToast('danger', this.$t('1127'), this.$t('1128', [type]))
    //     return null
    //   } else {
    //     this.showToast('danger', this.$t('1129'), this.$t('1130'))
    //     return null
    //   }
    // },
    // async getLocationPermission() {
    //   const isWeb = Capacitor.getPlatform() === 'web'
    
    //   if (isWeb) {
    //     if ('permissions' in navigator) {
    //       try {
    //         const status = await navigator.permissions.query({ name: 'geolocation' })
    
    //         if (status.state === 'granted') return { granted: true }
    //         if (status.state === 'denied') return { granted: false, reason: 'denied' }
    //         // If prompt (first time), trigger getCurrentPosition to prompt
    //         return new Promise((resolve) => {
    //           navigator.geolocation.getCurrentPosition(
    //             () => resolve({ granted: true }),
    //             () => resolve({ granted: false, reason: 'prompt-denied' }) // user denied after prompt
    //           )
    //         })
    //       } catch (e) {
    //         // Older browsers fallback
    //         return new Promise((resolve) => {
    //           navigator.geolocation.getCurrentPosition(
    //             () => resolve({ granted: true }),
    //             () => resolve({ granted: false, reason: 'unknown' })
    //           )
    //         })
    //       }
    //     } else {
    //       return { granted: false, reason: 'not-supported' }
    //     }
    //   } else {
    //     try {
    //       // Native (iOS / Android via Capacitor)
    //       const isGranted = (perm) =>
    //         ['granted', 'always', 'whenInUse'].includes(perm.location)
      
    //       let status = await Geolocation.checkPermissions()
      
    //       if (isGranted(status)) return { granted: true }
      
    //       if (status.location === 'denied') {
    //         return { granted: false, reason: 'denied' } // Already denied, show "open settings"
    //       }
      
    //       await Geolocation.requestPermissions()
    //       status = await Geolocation.checkPermissions()
      
    //       if (isGranted(status)) return { granted: true }
      
    //       return { granted: false, reason: 'prompt-denied' } // User denied after prompt
    //     }
    //     catch (error) {
    //       this.showToast('danger', this.$t('1131'), this.$t('1132'))
    //       this.$root.$emit('show-enable-device-location-modal')
    //     }
        
    //   }
    // },
    // async getCurrentLocation() {
    //   try {    
    //     const position = await Geolocation.getCurrentPosition(
    //       {
    //         enableHighAccuracy: true,   // Try GPS if available
    //         timeout: 15000,             // Wait up to 15 seconds
    //         maximumAge: 10000           // Allow using a cached location up to 10 sec old
    //       }
    //     )
    //     console.log('positionnnns: ', position)
    //     const lat = position.coords.latitude
    //     const lng = position.coords.longitude
    //     console.log('Native Latitude:', lat, 'Longitude:', lng)
    //     return {lat: lat, lng: lng}
    //   } catch (error) {
    //     console.error('Error getting location:', error.message || error);
    //     return null
    //   }
    // },
    async ifUserInsideAreaForClockin(position){
      // const userLocation = await this.getCurrentLocation()
    
      // if (userLocation === null) {
      //   this.showToast('danger', 'Location Unavailable', 'Location services appear to be turned off. Please enable location to clock in.')
      //   return false  // location is not enabled
      // }

      const clockinType = store.getters.EMPLOYEE_DATA?.geofencing_clockin_type
      if(clockinType == 1){
        return await this.checkIfUserInsideClockInArea(position)
      }
      else if(clockinType == 2){
        return await this.checkIfUserInsidePropertyBoundaries(position)
      }
      else{
        return null
      }
    },
    async ifUserInsideAreaForClockout(position){
      // const userLocation = await this.getCurrentLocation()
    
      // if (userLocation === null) {
      //   this.showToast('danger', 'Location Unavailable', 'Location services appear to be turned off. Please enable location to clock in.')
      //   return false  // location is not enabled
      // }

      const clockoutType = store.getters.EMPLOYEE_DATA?.geofencing_clockout_type
      if(clockoutType == 1){
        return await this.checkIfUserInsideClockInArea(position)
      }
      else if(clockoutType == 2){
        return await this.checkIfUserInsidePropertyBoundaries(position)
      }
      else{
        return null
      }
    },
    
    // async checkIfUserInsideClockInArea(position) {
    //   console.log('checking if inside clockin area')
    //   const clockinAreas = store.getters.EMPLOYEE_DATA?.geofencing?.clockin_areas || []
    //   //const userLocation = await this.getCurrentLocation()
    
    //   const userLatLng = new google.maps.LatLng(position.lat, position.lng)
    
    //   for (const area of clockinAreas) {
    //     const accuracyFeet = parseFloat(area.accuracy || 0)
    //     const accuracyMeters = this.feetToMeters(accuracyFeet)
    
    //     if (area.type === 'polygon' && Array.isArray(area.coords)) {
    //       const polygonCoords = area.coords.map(coord => ({
    //         lat: parseFloat(coord.lat),
    //         lng: parseFloat(coord.lng)
    //       }))
    //       const polygon = new google.maps.Polygon({ paths: polygonCoords })
    //       // Normal inside polygon check
    //       if (google.maps.geometry.poly.containsLocation(userLatLng, polygon)) {
    //         return area // inside polygon
    //       }
    //       // Check if within accuracy buffer distance from polygon boundary
    //       const distance = this.getDistanceToPolygon(userLatLng, polygon)
    //       if (distance <= accuracyMeters) {
    //         return area
    //       }
    //     }
    
    //     if (area.type === 'circle' && area.center && area.radius) {
    //       const center = new google.maps.LatLng(
    //         parseFloat(area.center.lat),
    //         parseFloat(area.center.lng)
    //       )
    //       const radius = parseFloat(this.feetToMeters(area.radius)) + accuracyMeters // add accuracy buffer to radius
    //       const distance = google.maps.geometry.spherical.computeDistanceBetween(userLatLng, center)
    //       if (distance <= radius) {
    //         return area // inside circle + accuracy buffer
    //       }
    //     }
    //   }
    
    //   return null // user is not inside any area
    // },
    async checkIfUserInsideClockInArea(position) {
      console.log('checking if inside clockin area')
      const clockinAreas = store.getters.EMPLOYEE_DATA?.geofencing?.clockin_areas || []
      const userLatLng = new google.maps.LatLng(position.lat, position.lng)
      const userAccuracyFeet = store.getters.EMPLOYEE_DATA?.geofencing?.gps_accuracy || 0
      const userAccuracyMeters = this.feetToMeters(userAccuracyFeet)

      for (const area of clockinAreas) {
        const areaAccuracyFeet = parseFloat(area.accuracy || 0)
        const areaAccuracyMeters = this.feetToMeters(areaAccuracyFeet)

        if (area.type === 'polygon' && Array.isArray(area.coords)) {
          const polygonCoords = area.coords.map(coord => ({
            lat: parseFloat(coord.lat),
            lng: parseFloat(coord.lng)
          }))
          const polygon = new google.maps.Polygon({ paths: polygonCoords })

          // if user is inside polygon
          if (google.maps.geometry.poly.containsLocation(userLatLng, polygon)) {
            return area
          }

          // distance from user to polygon edge
          const distance = this.getDistanceToPolygon(userLatLng, polygon)
          if (distance <= (areaAccuracyMeters + userAccuracyMeters)) {
            return area
          }
        }

        if (area.type === 'circle' && area.center && area.radius) {
          const center = new google.maps.LatLng(
            parseFloat(area.center.lat),
            parseFloat(area.center.lng)
          )

          const areaRadiusMeters = this.feetToMeters(area.radius)
          const totalRadius = areaRadiusMeters + areaAccuracyMeters + userAccuracyMeters

          const distance = google.maps.geometry.spherical.computeDistanceBetween(userLatLng, center)
          if (distance <= totalRadius) {
            return area
          }
        }
      }

      return null // user is not inside any area
    },
    async checkIfUserInsidePropertyBoundaries(position) {
      console.log('checking if inside property boundaries')

      const areas = store.getters.EMPLOYEE_DATA?.geofencing?.property_areas || []
      const userLat = parseFloat(position.lat)
      const userLng = parseFloat(position.lng)
      const userAccuracyFeet = store.getters.EMPLOYEE_DATA?.geofencing?.gps_accuracy || 0
      const userAccuracyMeters = this.feetToMeters(userAccuracyFeet)

      const userLatLng = new google.maps.LatLng(userLat, userLng)

      for (const area of areas) {
        const polygonCoords = area.coords.map(coord => ({
          lat: parseFloat(coord.lat),
          lng: parseFloat(coord.lng)
        }))

        // check if point is inside polygon
        if (this.isPointInsidePolygon(polygonCoords, userLat, userLng)) {
          return area
        }

        const polygon = new google.maps.Polygon({ paths: polygonCoords })

        // get distance from user to polygon edges
        const distance = this.getDistanceToPolygon(userLatLng, polygon)

        // Only use GPS accuracy for this type of area
        if (distance <= userAccuracyMeters) {
          return area
        }
      }

      return null // user not inside or near any property
    },
    isPointInsideCircle(center, radiusInMeters, userLat, userLng) {
      const earthRadius = 6371000 // meters
    
      const dLat = (center.lat - userLat) * Math.PI / 180
      const dLng = (center.lng - userLng) * Math.PI / 180
    
      const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(userLat * Math.PI / 180) * Math.cos(center.lat * Math.PI / 180) *
                Math.sin(dLng/2) * Math.sin(dLng/2)
    
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
    
      const distance = earthRadius * c
    
      return distance <= radiusInMeters
    },
    isPointInsidePolygon(polygon, userLat, userLng) {
      let inside = false
      const x = userLat
      const y = userLng
    
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = parseFloat(polygon[i].lat)
        const yi = parseFloat(polygon[i].lng)
        const xj = parseFloat(polygon[j].lat)
        const yj = parseFloat(polygon[j].lng)
    
        const intersect = ((yi > y) !== (yj > y)) &&
          (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
        if (intersect) inside = !inside
      }
    
      return inside
    },
    getDistanceToPolygon(point, polygon) {
      let minDistance = Infinity
      const path = polygon.getPath()
    
      for (let i = 0; i < path.getLength(); i++) {
        const segmentStart = path.getAt(i)
        const segmentEnd = path.getAt((i + 1) % path.getLength())
    
        const distance = google.maps.geometry.spherical.computeDistanceBetween(
          this.getClosestPointOnSegment(point, segmentStart, segmentEnd),
          point
        )
    
        if (distance < minDistance) {
          minDistance = distance
        }
      }
    
      return minDistance
    },
    
    getClosestPointOnSegment(point, start, end) {
      // Algorithm to get closest point on segment to a given point
      const A = start
      const B = end
      const P = point
    
      const a = google.maps.geometry.spherical.computeDistanceBetween(A, B)
      const b = google.maps.geometry.spherical.computeDistanceBetween(A, P)
      const c = google.maps.geometry.spherical.computeDistanceBetween(B, P)
    
      if (a === 0) return A
    
      const s = ((b ** 2) + (a ** 2) - (c ** 2)) / (2 * a)
      const ratio = Math.max(0, Math.min(1, s / a))
    
      const lat = A.lat() + (B.lat() - A.lat()) * ratio
      const lng = A.lng() + (B.lng() - A.lng()) * ratio
    
      return new google.maps.LatLng(lat, lng)
    },
    feetToMeters(feet) {
      return feet * 0.3048
    },
    metersToFeet(meters) {
      return parseInt(meters / 0.3048);
    },


    // -- upadted geolocation tracking flow new functions will start from here --

    checkIfEmployeeGeofencingEnabled(){
      return store.getters.EMPLOYEE_DATA?.geofencing?.enabled_for_employee
    },
    isGeofencingClockinSettingSet(){
      if(!this.checkIfEmployeeGeofencingEnabled()){
        return false
      }

      const clockinType = store.getters.EMPLOYEE_DATA?.geofencing_clockin_type

      // clockin areas and property areas check moved to backend
      // so just check if clockin area is not 'anywhere' => 0
      if(clockinType == 1 || clockinType == 2){
        return true
      }

      return false
    },
    isGeofencingClockOutSettingSet(){
      
      if(!this.checkIfEmployeeGeofencingEnabled()){
        return false
      }
      
      const clockoutType = store.getters.EMPLOYEE_DATA?.geofencing_clockout_type

      // clockin areas and property areas check moved to backend
      // so just check if clockout area is not 'anywhere' => 0
      if(clockoutType == 1 || clockoutType == 2){
        return true
      }

      return false
    },
    async getCurrentLocation(permissionType = 'silent') {  // two types: ask or silent
      try {
        console.log('getCurrentLocation caalled with permissionType: ', permissionType)

        const checkPerm = await this.checkLocationPermission()
        console.log('Check location permisisson: ', checkPerm)
        
        if(permissionType == 'ask'){
          if(!checkPerm.granted){
            const getPerm = await this.getLocationPermission()
            if(!getPerm.granted){
              console.log('Asked for permission but did not get granted', getPerm)
              return null
            }
          }
          else{
            // no need ask as we already have permission
            console.log('no need ask as we already have permission')
          }
        }
        else{
          if(!checkPerm.granted){ 
            // we dont have permission and we can not ask so return null silently
            console.log('we dont have permission and we can not ask so return null silently')
            return null
          }
        }

        // all case already handled above - at this point we have pemission to get location
        console.log('all case already handled above - at this point we have pemission to get location')

        // const position = await Geolocation.getCurrentPosition({
        //   enableHighAccuracy: true,   // Try GPS if available
        //   timeout: 15000,             // Wait up to 15 seconds
        //   maximumAge: 10000           // Allow using a cached location up to 10 sec old
        // })

        const position = await this.getCurrentPosition()

        // console.log('position: ', position)

        // this.showToast('danger', this.$t('1131'), `Got posiiton: ${position.coords.latitude}, ${position.coords.longitude}`)
        // return {
        //   lat: position.coords.latitude,
        //   lng: position.coords.longitude
        // }
        return {
          lat: position.lat,
          lng: position.lng
        }

      } catch (e) {
        // Ignore any errors silently
        //this.showToast('danger', this.$t('1131'), 'Error getting location:', e.message || e)
        console.log('Error getting location:', e.message || e);
        return null
      }
    },
    async checkLocationPermission() {
      const isWeb = Capacitor.getPlatform() === 'web'
    
      if (isWeb) {
        if ('permissions' in navigator) {
          try {
            const status = await navigator.permissions.query({ name: 'geolocation' })
    
            if (status.state === 'granted') return { granted: true }
            if (status.state === 'denied') return { granted: false, reason: 'denied' }
            // If prompt (first time), trigger getCurrentPosition to prompt
            // return new Promise((resolve) => {
            //   navigator.geolocation.getCurrentPosition(
            //     () => resolve({ granted: true }),
            //     () => resolve({ granted: false, reason: 'prompt-denied' }) // user denied after prompt
            //   )
            // })
            return { granted: false, reason: 'can-ask' }
          } catch (e) {
            return { granted: false, reason: 'unknown' }
            // Older browsers fallback
            // return new Promise((resolve) => {
            //   navigator.geolocation.getCurrentPosition(
            //     () => resolve({ granted: true }),
            //     () => resolve({ granted: false, reason: 'unknown' })
            //   )
            // })
          }
        } else {
          return { granted: false, reason: 'not-supported' }
        }
      } else {
        try {
          // Native (iOS / Android via Capacitor)
          const isGranted = (perm) =>
            ['granted', 'always', 'whenInUse'].includes(perm.location)
      
          let status = await Geolocation.checkPermissions()
      
          if (isGranted(status)) return { granted: true }
      
          if (status.location === 'denied') {
            return { granted: false, reason: 'denied' } // Already denied, show "open settings"
          }

          return { granted: false, reason: 'not-allowed' }
          
          // await Geolocation.requestPermissions()
          // status = await Geolocation.checkPermissions()
      
          // if (isGranted(status)) return { granted: true }
      
          // return { granted: false, reason: 'prompt-denied' } // User denied after prompt
        }
        catch (error) {
          // this.showToast('danger', this.$t('1131'), this.$t('1132'))
          // this.$root.$emit('show-enable-device-location-modal')
          return { granted: false, reason: 'unknown' }
        }
        
      }
    },
    async getLocationPermission() {
      const isWeb = Capacitor.getPlatform() === 'web'
    
      if (isWeb) {
        if ('permissions' in navigator) {
          try {
            const status = await navigator.permissions.query({ name: 'geolocation' })
    
            // if (status.state === 'granted') return { granted: true }
            // if (status.state === 'denied') return { granted: false, reason: 'denied' }
            // If prompt (first time), trigger getCurrentPosition to prompt
            return new Promise((resolve) => {
              navigator.geolocation.getCurrentPosition(
                () => resolve({ granted: true }),
                () => resolve({ granted: false, reason: 'prompt-denied' }) // user denied after prompt
              )
            })
          } catch (e) {
            // Older browsers fallback
            return new Promise((resolve) => {
              navigator.geolocation.getCurrentPosition(
                () => resolve({ granted: true }),
                () => resolve({ granted: false, reason: 'unknown' })
              )
            })
          }
        } else {
          return { granted: false, reason: 'not-supported' }
        }
      } else {
        try {
          // Native (iOS / Android via Capacitor)
          const isGranted = (perm) =>
            ['granted', 'always', 'whenInUse'].includes(perm.location)
      
          // let status = await Geolocation.checkPermissions()
      
          // if (isGranted(status)) return { granted: true }
      
          // if (status.location === 'denied') {
          //   return { granted: false, reason: 'denied' } // Already denied, show "open settings"
          // }
      
          await Geolocation.requestPermissions()
          let status = await Geolocation.checkPermissions()
      
          if (isGranted(status)) return { granted: true }
      
          return { granted: false, reason: 'prompt-denied' } // User denied after prompt
        }
        catch (error) {
          this.showToast('danger', this.$t('1131'), this.$t('1132'))
          this.$root.$emit('show-enable-device-location-modal')
        }
        
      }
    },
    async getCurrentPosition(){

      try {
        console.log('getCurrentPosition() called')
        const permission =  await this.checkLocationPermission()
        console.log('permission: ', permission)
        if(permission.granted) {

          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,   // Try GPS if available
            timeout: 15000,             // Wait up to 15 seconds
            maximumAge: 10000           // Allow using a cached location up to 10 sec old
          })
    
          console.log('position: ', position)
    
          // this.showToast('danger', this.$t('1131'), `Got posiiton: ${position.coords.latitude}, ${position.coords.longitude}`)
          return {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }

        }
        else{
          return null
        }
        
      }
      catch (e) {
        // Ignore any errors silently
        //this.showToast('danger', this.$t('1131'), 'Error getting location:', e.message || e)
        console.log('Error getting location:', e.message || e);
        return null
      }

    },
    hasUserConsentOnGeolocation(){
      if(this.checkIfEmployeeGeofencingEnabled() && store.getters.EMPLOYEE_DATA?.allow_tracking_consent == 0){
        return false
      }
      return true
    },
    getUserConsentOnGeolocation(){
      this.$root.$emit('check-tracking-consent')
    },
    async getClockingInArea(clockingInOutType = 'clockin'){
      let clockingArea = null
      const permission =  await this.getLocationPermission()

      if(permission.granted) {
        const position = await this.getCurrentPosition()
        if(position){
          if(clockingInOutType == 'clockin'){
            clockingArea = await this.ifUserInsideAreaForClockin(position)
          }
          else if(clockingInOutType == 'clockout'){
            clockingArea = await this.ifUserInsideAreaForClockout(position)
          }
          if(clockingArea === null){
            this.$root.$emit('show-clocking-outside-area-modal', clockingInOutType)
            return null
          }
          else{
            return clockingArea
          }
        }
        else{
          this.showToast('danger', this.$t('1125'), this.$t('1126'))
        }
      } else if (permission.reason === 'denied') {
        this.$root.$emit('show-enable-location-permission-modal')
        return null
      } else if (permission.reason === 'prompt-denied') {
        // User denied location after being prompted
        const type = (clockingInOutType == 'clockin') ? 'clock in' : 'clock out'
        this.showToast('danger', this.$t('1127'), this.$t('1128', [type]))
        return null
      } else {
        this.showToast('danger', this.$t('1129'), this.$t('1130'))
        return null
      }
    },
  },
  filters:{
  }
}